export default __webpack_public_path__ + "static/media/Green0005.68c9c317.png";